module.exports = __webpack_public_path__ + "img/support-img.08dcd8a1.jpg";